<template>
    <div>
      <v-list
        class="pt-0"
        two-line
      >
        <div class="fixed-header ma-0">
          <v-row class="px-5 ">
            <v-col
              class="ml-2 mt-3"
              cols="auto"
            >
              <h2 class="font-weight-600">Notifications</h2>
            </v-col>
            <v-col class="mt-3 pl-0">
              <v-badge
                v-if="$store.state.ui.notifications.unread != 0 && $vuetify.breakpoint.smAndDown "
                color="#F3425C"
                top
                :class="$store.state.ui.notifications.unread > 99 ? 'px-3' : ''"
              >
                <template v-slot:badge>
                  <span class="font-weight-bold">
                    {{ $store.state.ui.notifications.unread > 99 ? '99+' : $store.state.ui.notifications.unread }}
                  </span>
                </template>
              </v-badge>
            </v-col>
            <v-col cols="1">
              <v-btn
                class="text-right"
                icon
                @click.stop="
                  $store.commit('ui/drawer.right.toggle')
                "
              >
                <v-icon
                  style="background-color:transparent"
                  medium
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="pt-0"
            >
              <router-link
                tag="button"
                :to="'/accounts/' + $store.getters['auth/account'].id + '/notifications'"
                class="ml-8 mb-xs-0 mb-3"
              >
                <v-btn
                  v-track="'settings-notification-see-all'"
                  outlined
                  color="dark seconday--font"
                  @click="closeNotificationDrawer"
                >
                  See All
                </v-btn>
              </router-link>
              <v-btn
                v-track="'settings-notification-mark-all-read'"
                outlined
                color="dark seconday--font"
                class="ml-sm-3 ml-8"
                @click="readAllNotification"
              >
                MARK ALL AS READ
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
        </div>
        <v-skeleton-loader 
          :loading="$store.state.ui.notifications.loading"
          type="list-item-avatar-two-line"
          class="mx-auto"
        >
          <template v-if="$store.state.ui.notifications.data.length == 0">
            <v-row class="ma-5">
              <v-col class="subtitle-2">
                <h3>No notifications, you are up to date!</h3>
                <v-img
                  src="@core/assets/images/no-notifications-box.svg"
                />
              </v-col>
            </v-row>
          </template>
          <template
            v-for="(item, index) in $store.state.ui.notifications.data"
            v-else
          >
            <v-list-item
              :key="index"
              class="custom-list"
            >
              <v-list-item-avatar
                class="mx-0 pa-0"
              >
                <v-icon
                  v-if="item.is_unread"
                  class="custom-icon mt-1"
                  small
                  color="blue lighten-1"
                >
                  mdi-circle
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content
                :class="item.is_unread ? 'font-weight-bold' : ''"
                class="custom-list body-1"
              >
                <v-list-item-title v-html="item.message" />
              </v-list-item-content>
              <v-list-item-action class="pa-0">
                <v-list-item-action-text
                  v-if="$vuetify.breakpoint.smAndUp"
                  :class="item.is_unread ? 'font-weight-bold' : ''"
                  color="#4E4E4F"
                >
                  {{
                    item.notification_date | formatDate('MMM D')
                  }}
                </v-list-item-action-text>
                <template>
                 <div v-if="item.status === 1 && item.show_download === true">
                  <div v-if="item.notifable_type == 'List'">
                    <v-tooltip :disabled="checkRole('download_contacts')"  color="rgba(0, 0, 0, 0.9)" top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-btn
                          v-track="'settings-notification-download'"
                          :disabled="!checkRole('download_contacts')"
                          fab
                          color="#03b6fc"
                          small
                          class="mt-2"
                          @click="downloadDocument(item.download_url)"
                        >
                          <v-icon class="white--text">mdi-download</v-icon>
                        </v-btn>
                      </div>
                    </template>
                      <span>No access to download</span>
                  </v-tooltip>
                  </div>
                  <div v-else>
                    <v-btn
                      v-track="'settings-notification-download'"
                      fab
                      color="#03b6fc"
                      small
                      class="mt-2"
                      @click="downloadDocument(item.download_url)"
                    >
                      <v-icon class="white--text">mdi-download</v-icon>
                    </v-btn>
                  </div>
                 </div>
                </template>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < 9"
              :key="item.id"
            />
          </template>
        </v-skeleton-loader>
      </v-list>
      <div class="d-none" id="downloadframeDiv">
  </div>
    <v-overlay :value="$store.state.ui.notifications.loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </div>
</template>
  
<script>
    import { $notifications } from '@core/services'
    import { mapGetters } from 'vuex'
    import { createDownloadLink } from '@core/config/utils'
    export default {
      data () {
        return {}
      },
      computed:{
        ...mapGetters({
        checkRole: 'auth/checkRole'
        })
      },
      methods: {
        closeNotificationDrawer () {
          this.$store.commit('ui/drawer.right.toggle',false)
        },
        readAllNotification () {
          $notifications.markAllRead().then(response => {
            this.$store.commit('ui/notifications.unread',0)
            this.$store.dispatch('ui/getNotifications')
          })
        },
       async downloadDocument (downloadLink) {
          let downloadUrl = this.$config.RAILS_BASE_URL + downloadLink
          downloadUrl = await createDownloadLink(downloadUrl)
          var html = '<iframe src="' + downloadUrl +'"></iframe>'
          document.getElementById('downloadframeDiv').innerHTML = html
        },
      },
    }
  </script>
  
  <style scoped>
  .custom-list div {
    white-space: normal !important;
  }
  .custom-icon {
    align-items: flex-start !important;
  }
  .custom-list:hover {
    background-color: #f2f3f4;
  }
  .v-btn:before {
    background-color: transparent;
  }
  .fixed-header {
    position: sticky;
    top: 0px;
    background: white !important;
    z-index: 10;
  }
  
  </style>
  